import { defineComponent as _defineComponent } from 'vue'


interface Props {
	/**
	 * 「トークルームが1件も投稿ない時」文言。
	 */
	talkRoomNotFoundText: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    talkRoomNotFoundText: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * 「トークルームが1件も投稿ない時」文言。
	 */
	talkRoomNotFoundText: string;
}
/**
 * トークルーム0件時の表示。
 */



const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})